import component from './SeoBannerSearchHotels';

export default component;
